import gql from 'graphql-tag'

export const userFragment = gql`
fragment user on User {
  id
  email
  name
  avatar
}
`

export const userAccountFragment = gql`
fragment userAccount on UserAccount {
  id
  email
  profileLabel
  provider {
    id
    name
    logo
    darkModeLogo
  }
}
`
